import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import 'katex/dist/katex.min.css';


// Home Components
import Home from './pages/home/Home';
import Navbar from './pages/home/Navbar';

// Quiz Components
import Quiz from './pages/quiz/Quiz';
import QuizStarting from './pages/pages/QuizStarting';
import QuizDetailsPage from './pages/pages/QuizDetailsPage';
import QuizNumber from './pages/pages/QuizNumber';
import NumberOfQuestions from './pages/pages/NumberOfQuestions';
import PageNotFound from './pages/home/PageNotFound';

import QuizReStarting from './pages/pages/QuizReStarting';

import Bottombar from './pages/home/Bottombar';
import About from './pages/home/About';
import Contact from './pages/home/Contact';
import PrivacyPolicy from './pages/home/PrivacyPolicy';
import Footer from './pages/home/Footer';
import PDFViewer from './pages/topics/PDFViwer';
import MoreOptions from './pages/home/MoreOptions';

import Page from './pages/pages/Page';
import OnlineReadBook from './pages/pages/OnlineReadBook';
import QuizMathTopics from './pages/quiz/subjects/QuizMathTopics';
import QuestionSolution from './pages/pages/QuestionSolution';
import QuizPhysicsTopics from './pages/quiz/subjects/QuizPhysicsTopics';
import QuizChemistryTopics from './pages/quiz/subjects/QuizChemistryTopics';
import Syllabus from './pages/syllabus/Syllabus';
import SyllabusPhy from './pages/syllabus/subjects/SyllabusPhys';
import SyllabusChem from './pages/syllabus/subjects/SyllabusChem';
import SyllabusMath from './pages/syllabus/subjects/SyllabusMath';
import ChapterWiseWeightage from './pages/ChapterWiseWeightage/ChapterWiseWeightage';
import ChapterWiseWeightagePhysTopics from './pages/ChapterWiseWeightage/subjects/ChapterWiseWeightagePhysTopics';
import ChapterWiseWeightageChemTopics from './pages/ChapterWiseWeightage/subjects/ChapterWiseWeightageChemTopics';
import ChapterWiseWeightageMathTopics from './pages/ChapterWiseWeightage/subjects/ChapterWiseWeightageMathTopics';
import StudyPlanner from './pages/page/StudyPlanner';
import StudyTimeTable from './pages/page/StudyTimeTable';
import DownloadImages from './pages/testpages/DownloadImages';
import ViewImages from './pages/testpages/ViewImages';
import DownloadPDF from './pages/testpages/DownloadPDF';
import PYQMockTest from './pages/PreviousYearMockTest/PYQMockTest';
import PYQMocktestYear from './pages/PreviousYearMockTest/PYQMocktestYear';
import NumberOfQuestionsYear from './pages/pages/NumberOfQuestionsYear';

// Offline Components from your src/OffLinePage/ folder
// (Update these filenames to match whatever you named them inside src/OffLinePage)
// import GenericOffline from './OffLinePage/offline';
// import DashboardOffline from './OffLinePage/dashboard-offline';
// import ProfileOffline from './OffLinePage/profile-offline';

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

const AppContent = () => {
  const location = useLocation();
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  // Monitor network connection status globally
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <>
      {/* Offline Status Warning Banner */}
      {!isOnline && (
        <div style={{
          background: '#e74c3c',
          color: 'white',
          textAlign: 'center',
          padding: '5px',
          fontSize: '12px',
          fontWeight: 'bold',
          position: 'sticky',
          top: 0,
          zIndex: 9999
        }}>
          ⚠️ You are currently offline. Running in offline mode.

        </div>
      )}

      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&
        <Navbar />}

      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&
        !location.pathname.startsWith('/online-practics-questions') &&
        !location.pathname.startsWith('/practivs-important-questions') &&
        !location.pathname.startsWith('/practice-random-question/all') &&
        !location.pathname.startsWith('/practice-random-question/physics') &&
        !location.pathname.startsWith('/practice-random-question/chemistry') &&
        !location.pathname.startsWith('/practice-random-question/biology') &&
        !location.pathname.startsWith('/pdfviewer') &&
        !location.pathname.startsWith('/onlinereadbook') &&
        !location.pathname.startsWith('/account-deletion') &&
        <Bottombar />}

      <Routes>
        {/* Public Routes */}
        <Route path='/' element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route path="/image-download" element={<DownloadImages />} />
        <Route path="/view-images" element={<ViewImages />} />
        <Route path="/download-pdf" element={<DownloadPDF />} />

        <Route path="/page" element={<Page />} />
        <Route path="/more-options" element={<MoreOptions />} />

        <Route path="/pdfviewer/:pdfId/:pdfName/:fileId" element={<PDFViewer />} />
        <Route path="/onlinereadbook/:type/:subject/:topic" element={<OnlineReadBook />} />
        <Route path="/question-solution/:id" element={<QuestionSolution />} />

        {/* Quiz Routes */}
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/quiz/Mathematics" element={<QuizMathTopics />} />
        <Route path="/quiz/physics" element={<QuizPhysicsTopics />} />
        <Route path="/quiz/chemistry" element={<QuizChemistryTopics />} />
       
       {/* PYQ Quiz Routes */}
        <Route path="/pyq-mock-test" element={<PYQMockTest />} />
        <Route path="/pyq-mock-test/mathematics" element={<QuizMathTopics />} />
        <Route path="/pyq-mock-test/physics" element={<QuizPhysicsTopics />} />
        <Route path="/pyq-mock-test/chemistry" element={<QuizChemistryTopics />} />
        <Route path="/pyq-mock-test-year/:type/:subject/:topic/:subjectName" element={<PYQMocktestYear />} />
        <Route path="/number-of-questions-year/:type/:subject/:topic/:quizNo/:subjectName" element={<NumberOfQuestionsYear />} />

        <Route path="/quiz-starting/:type/:subject/:topic/:quizNo/:quesNum/:subjectName" element={<QuizStarting />} />
        <Route path="/quiz-restarting/:quizsubjectName/:quizId/:id" element={<QuizReStarting />} />
        <Route path="/quiz-details/:quizId" element={<QuizDetailsPage />} />
        <Route path="/quiz-number/:type/:subject/:topic/:subjectName" element={<QuizNumber />} />
        <Route path="/number-of-questions/:type/:subject/:topic/:quizNo/:subjectName" element={<NumberOfQuestions />} />

        {/* Syllabus Routes */}
        <Route path="/syllabus" element={<Syllabus />} />
        <Route path="/syllabus/physics" element={<SyllabusPhy />} />
        <Route path="/syllabus/chemistry" element={<SyllabusChem />} />
        <Route path="/syllabus/mathematics" element={<SyllabusMath />} />

        {/* Chapter Weightage Routes */}
        <Route path="/chapter-wise-weightage" element={<ChapterWiseWeightage />} />
        <Route path="/chapter-wise-weightage/physics" element={<ChapterWiseWeightagePhysTopics />} />
        <Route path="/chapter-wise-weightage/chemistry" element={<ChapterWiseWeightageChemTopics />} />
        <Route path="/chapter-wise-weightage/mathematics" element={<ChapterWiseWeightageMathTopics />} />

        {/* Study Planner Routes */}
        <Route path="/jee-main-study-planner" element={<StudyPlanner />} />
        <Route path="/jee-main-study-time-table" element={<StudyTimeTable />} />

        {/* 404 Route */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>

      {!location.pathname.startsWith('/quiz-starting') &&
        !location.pathname.startsWith('/quiz-restarting') &&
        !location.pathname.startsWith('/online-practics-questions') &&
        !location.pathname.startsWith('/practivs-important-questions') &&
        !location.pathname.startsWith('/practice-random-question/all') &&
        !location.pathname.startsWith('/practice-random-question/physics') &&
        !location.pathname.startsWith('/practice-random-question/chemistry') &&
        !location.pathname.startsWith('/practice-random-question/biology') &&
        !location.pathname.startsWith('/onlinereadbook') &&
        <Footer />}
    </>
  );
};

export default App;